import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import SmoothScroll from "./components/SmoothScroll";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCTAs from "./components/FloatingCTAs";

import Home from "./pages/Home";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import PrivateTrips from "./pages/PrivateTrips";
import PrivateTripDetail from "./pages/PrivateTripDetail";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";

import { AdminLogin, AuthCallback, ProtectedAdmin } from "./pages/admin/AdminShell";
import { AdminOverview, AdminTrips, AdminBlogs, AdminTestimonials, AdminEnquiries, AdminAccess } from "./pages/admin/AdminPages";
import { AdminClients, AdminItineraries, ClientDetail } from "./pages/admin/AdminCRM";

function AppRouter() {
  const loc = useLocation();
  // Handle Emergent auth callback (session_id in hash)
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;

  const isAdmin = loc.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:id" element={<TripDetail />} />
        <Route path="/private-trips" element={<PrivateTrips />} />
        <Route path="/private-trips/:id" element={<PrivateTripDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedAdmin><AdminOverview /></ProtectedAdmin>} />
        <Route path="/admin/trips" element={<ProtectedAdmin><AdminTrips /></ProtectedAdmin>} />
        <Route path="/admin/blogs" element={<ProtectedAdmin><AdminBlogs /></ProtectedAdmin>} />
        <Route path="/admin/testimonials" element={<ProtectedAdmin><AdminTestimonials /></ProtectedAdmin>} />
        <Route path="/admin/enquiries" element={<ProtectedAdmin><AdminEnquiries /></ProtectedAdmin>} />
        <Route path="/admin/clients" element={<ProtectedAdmin><AdminClients /></ProtectedAdmin>} />
        <Route path="/admin/clients/:id" element={<ProtectedAdmin><ClientDetail /></ProtectedAdmin>} />
        <Route path="/admin/itineraries" element={<ProtectedAdmin><AdminItineraries /></ProtectedAdmin>} />
        <Route path="/admin/access" element={<ProtectedAdmin><AdminAccess /></ProtectedAdmin>} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingCTAs />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <SmoothScroll>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </SmoothScroll>
      </HelmetProvider>
    </div>
  );
}

export default App;
